import { Context } from '@leverege/plugin';
import { GlobalState } from '@leverege/ui-redux';
import { create } from './PairAction';
function processRelationship(molten, relationship, options) {
  const {
    attribute,
    parentBlueprint,
    blueprint,
    path,
    parentRelationship
  } = relationship || {};
  if (!attribute?.hasTag('is:pairing')) {
    return;
  }
  const objectName = blueprint?.name;
  const parentObjectName = parentBlueprint?.name;
  const parentObjectType = parentBlueprint?.type;
  const parentNetworkId = parentBlueprint?.getTagsStartingWith('network:', true)[0];
  const networkId = blueprint?.getTagsStartingWith('network:', true)[0];
  molten.addPlugin('Action', {
    id: `recovr.${path}.pair`,
    name: `Pair ${objectName} from ${parentObjectName}`,
    layout: {
      sort: 'pair.locator',
      sectionName: 'Pairing'
    },
    matches: [{
      client: ['GroupScreen', 'ItemInfoScreen', 'DataCardDetail'],
      use: 'actionBar',
      path: parentRelationship.path,
      objectType: parentObjectType
    }, {
      use: 'contextMenu',
      path: parentRelationship.path,
      objectType: parentObjectType
      // usedIn : '!toolbar'
    }, {
      client: 'Main',
      use: 'headerOptions'
    }, {
      client: 'MapBoxRolloverSelectionPointer',
      use: 'contextMenu'
    }],
    prepare: async cxt => {
      const {
        clientState,
        clientProps
      } = cxt;
      const delegate = clientProps?.delegate || clientState?.actionsContext?.clientProps?.delegate;
      if (delegate.relationship.isItem) {
        return GlobalState.dispatch(delegate.parent().requestCanCreate());
      }
      return GlobalState.dispatch(delegate.requestCanCreate());
    },
    isPrepared: cxt => {
      const {
        clientState,
        clientProps
      } = cxt;
      const delegate = clientProps?.delegate || clientState?.actionsContext?.clientProps?.delegate;
      if (delegate.relationship.isItem) {
        return delegate.parent().canCreate(undefined, undefined, undefined, false) != null;
      }
      return delegate.canCreate(undefined, undefined, undefined, false) != null;
    },
    handles: cxt => {
      const {
        client,
        clientState,
        clientProps
      } = cxt;
      const rel = clientProps?.relationship || clientState?.actionsContext?.clientProps?.relationship;
      if (rel?.path !== parentRelationship.path) {
        return false;
      }
      const delegate = clientProps?.delegate || clientState?.actionsContext?.clientProps?.delegate;
      let can;
      if (delegate.relationship.isItem) {
        can = delegate.parent().canCreate();
      } else {
        can = delegate.canCreate();
      }
      if (can !== true) {
        return false;
      }
      if (client === 'Main') {
        const {
          clientState
        } = cxt;
        return clientState?.actionsContext?.clientProps?.relationship?.path === parentRelationship.path;
      }
      const target = Context.getTarget(cxt);
      return !target || target.type === 'vehicle';
    },
    ...create({
      parentNetworkId,
      parentObjectName,
      objectName,
      parentBlueprint,
      networkId,
      blueprint,
      attribute,
      relationship
    })
  });
}
export default {
  install(molten) {
    molten.addPlugin('Molten.blueprintRelationshipProcessor', {
      type: 'recovr.PairUnpairActionCreator',
      processRelationship
    });
  }
};